// Module
var code = "<div class=\"\"> <!-- ko with: _colorModel --> <!-- ko template: {html: $data.GetTemplate.bind($data)} --><!-- /ko --> <!-- /ko --> </div> ";
// Exports
export default code;